import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'sellerProfileTypeFilter'})
export class SellerProfileTypeFilter implements PipeTransform {
    transform(Profile: any[]): any {

        return Profile.filter(Profile => ((Profile.profile_type > 1 && Profile.profile_type < 6) && Profile.profile_status < 2));

    }
}